function memoize(fn) {
  const memoized = {};
  return (arg) => {
    const ar = JSON.stringify(arg);
    if (typeof memoized[ar] === 'undefined') {
      memoized[ar] = fn(arg);
    }
    return memoized[ar];
  }
}

export default memoize;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/memoize.js
 **/